import { scripts } from './scripts'

export const scriptLoader = () => {
  scripts().forEach(
    ({ shouldLoad, execute, appendAt = 'head', scriptProperties, isFirst }) => {
      if (shouldLoad) {
        const scriptTag = document.createElement('script')
        if (scriptProperties && typeof scriptProperties === 'object') {
          Object.keys(scriptProperties).forEach((key) => {
            scriptTag.setAttribute(key, scriptProperties[key])
          })
        }
        if (execute) {
          scriptTag.type = 'text/javascript'
          scriptTag.innerHtml = execute()
        }
        const appendedAt = document[appendAt]
        if (isFirst) {
          appendedAt.insertBefore(scriptTag, appendedAt.firstElementChild)
        } else {
          appendedAt.appendChild(scriptTag)
        }
      }
    }
  )
}
